import Environment from '../environment/Environment';
import { IPlanningRow } from '../interfaces/sales-plan-planning.interface';

export const GetParentElements = (array, search) => {
  if (array.name === search) {
    return [array.name];
  } else if ((array.children) || Array.isArray(array)) {
    let children = Array.isArray(array) ? array : array.children;
    for (let child of children) {
      let result = GetParentElements(child, search);
      if (result) {
        if (array.name) {
          result.unshift(array.name);
        }
        return result;
      }
    }
  }
};

export const TwoDecimalPlace = (value) => {
  const numericValue = parseFloat(value) || 0;
  return parseFloat(numericValue.toFixed(2));
};

export const OneDecimalPlace = (value) => {
  const numericValue = parseFloat(value) || 0;
  return parseFloat(numericValue.toFixed(1));
};

export const RoundingDown = (value) => {
  return Math.floor(value);
};

export const LineType = (group: string) => {
  if (group === 'UNITS') {
    return 'solid';
  }

  if (group === 'REVENUE') {
    return 'dotted';
  }

  if (group === 'MARGINS') {
    return 'dashed';
  }

  return '';
};

export const BoxType = (group: string) => {
  if (group === 'REVENUE') {
    return 'angle-strip';
  }

  if (group === 'MARGINS') {
    return 'horizontal-strip';
  }

  return '';
};

export const StrokeDasharrayValue = (group: string) => {
  if (group === 'UNITS') {
    return 0;
  }

  if (group === 'REVENUE') {
    return 6;
  }

  if (group === 'MARGINS') {
    return 3;
  }

  return '';
};

export const NoOfDays = (fromDate: string, toDate: string): number => {
  const oneDay = 24 * 60 * 60 * 1000;
  const startDate: any = new Date(fromDate);
  const endDate: any = new Date(toDate);
  const dateDiff = endDate.getTime() - startDate.getTime();
  return Math.round(Math.abs(dateDiff / oneDay)) + 1;
};

export const StartOfWeek = (date: Date): any => {
  const oneDay = 24 * 60 * 60 * 1000;
  const weekday = date.getDay();

  return new Date(date.getTime() - Math.abs(0 - weekday) * oneDay);
};

export const NoOfWeeks = (fromDate: string, toDate: string) => {
  const week = 7 * 24 * 60 * 60 * 1000;
  const startDate: Date = new Date(fromDate);
  const endDate: Date = new Date(toDate);
  const dateDiff = endDate.getTime() - startDate.getTime();
  return Math.round(Math.abs(dateDiff / week));
};

export const TwoDecimalPlaceHandler = (value: string): string => {
  const reg = /^-?[0-9]*(\.[0-9]{0,2})?$/;
  if (value === '' || reg.test(value)) {
    return value;
  }
  return ''
};

export const FindSelectedElement = (array, fn) => {
  return array.reduce((acc, obj) => {
    let children = FindSelectedElement(obj.children || [], fn);
    if (fn(obj) || children.length) {
      acc.push(Object.assign({}, obj, children.length && { children }));
    }
    return acc;
  }, []);
};

export const GetSelectElements = (array, filterType: string, result: string[] = []) => {
  for (const item of array) {
    // if (item.selected) {
    // if (!item.children.length || (item.children && item.children.filter(child => child.selected).length > 0)) {
    if (!item.children.length) {
      filterType === 'product' ? result.push(item.code) : result.push(item.value);
      continue;
    }

    // Iterate over the children if there is any
    GetSelectElements(item.children, filterType, result);
  }
  // }

  return result;
};

let locationList: string[] = [];

export const GetSelectCountries = (array) => {
  const arr = array.filter((obj) => obj.selected)
    .reduce((acc, obj) => {
      if (!!!obj.children.length && obj.selected) {
        acc.push(obj.code);
        acc.push(obj.name);
      }
      GetSelectCountries(obj.children || []);
      return acc;
    }, []);
  if (!!arr.length) {
    locationList = arr;
  }
  return locationList;
};

let arrLevels: string[] = [];
export const GetLastLevelName = (array) => {
  const arr = array.filter((obj) => obj.selected)
    .reduce((acc, obj) => {
      if (!!!obj.children.length && obj.selected) {
        acc.push(obj.name);
      }
      GetLastLevelName(obj.children || []);
      return acc;
    }, []);

  if (!!arr.length) {
    arrLevels = arr;
  }

  return arrLevels;
};

export const NumberFormatter = (num: number): string => {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'K' },
    /*{value: 1e6, symbol: 'M'},
    {value: 1e9, symbol: 'G'},
    {value: 1e12, symbol: 'T'},
    {value: 1e15, symbol: 'P'},
    {value: 1e18, symbol: 'E'}*/
  ];
  const regex = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const item = lookup.slice().reverse().find((item) => Math.abs(num) >= item.value);
  return item ? (num / item.value).toFixed(2).replace(regex, '$1') + item.symbol : '0';
};

export const FindNextLargeNumber = (num: number): number => {
  const numStr = Math.round(Math.abs(num)).toString();
  const len = numStr.length;
  const firstChar = numStr.charAt(0);

  return (parseInt(firstChar) + 1) * 10 ** (len - 1) * (IsNegative(num) ? -1 : 1);
};

export const IsNegative = (num): boolean => {
  return Math.sign(num) === -1;
};

export const NumberWithCommas = (x: number): string => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const GetPlanId = (path: string): string => {
  const data = sessionStorage.getItem(Environment.PROJECT + 'plan');
  if (!!data) {
    const planList = JSON.parse(data);
    const details = planList.find((obj) => obj.path === path.substring(1));

    if (details !== undefined) {
      return details.planId;
    }
  }

  return '';
};

export const ObjToQueryString = (queryParams) => {
  const keyValuePairs: string[] = [];

  if (queryParams === undefined) {
    return '';
  }

  for (const key in queryParams) {
    if (queryParams.hasOwnProperty(key)) {
      keyValuePairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(queryParams[key]));
    }
  }
  return Object.keys(queryParams).length !== 0 ? ('?' + keyValuePairs.join('&')) : '';
};

export const getRatioSelectionOfPlanningGridForWeek = (
  rowArr: IPlanningRow[],
  qIdx: number,
  wIdx: number,
  oldVal,
): string => {
  const unitIdx = rowArr.findIndex(row => row.name === 'UNITS');
  const forecastUnitIdx = rowArr[unitIdx].measures
    .findIndex(measure => measure.name === 'Forecast Unconstrained U');
  const lyUnitIdx = rowArr[unitIdx].measures
    .findIndex(measure => measure.name === 'LY - Actuals U');
  const forecastVal = rowArr[unitIdx].measures[forecastUnitIdx].quarters[qIdx].weeks[wIdx].value;
  const lyVal = rowArr[unitIdx].measures[lyUnitIdx].quarters[qIdx].weeks[wIdx].value;

  const weekLength = rowArr[unitIdx].measures[forecastUnitIdx].quarters[qIdx].weeks.length;
  const isValidForecast = rowArr[unitIdx].measures[forecastUnitIdx].quarters[qIdx].weeks[weekLength - 1].value > 0;

  return getRatioSelection(oldVal, forecastVal, lyVal, isValidForecast);
};

export const getRatioSelectionOfPlanningGridForQuarter = (
  rowArr: any[],
  qIdx: number,
  oldVal,
  flag
): string => {
  const unitIdx = rowArr.findIndex(row => row.name === 'UNITS');
  const forecastUnitIdx = rowArr[unitIdx].measures
    .findIndex(measure => measure.name === 'Forecast Unconstrained U');
  const lyUnitIdx = rowArr[unitIdx].measures
    .findIndex(measure => measure.name === 'LY - Actuals U');
  const forecastVal = rowArr[unitIdx].measures[forecastUnitIdx].quarters[qIdx].value;
  const lyVal = rowArr[unitIdx].measures[lyUnitIdx].quarters[qIdx].value;

  const weekLength = flag
  ? rowArr[unitIdx].measures[forecastUnitIdx].quarters[qIdx].months?.length || 0
  : rowArr[unitIdx].measures[forecastUnitIdx].quarters[qIdx].weeks?.length || 0;

  const isValidForecast =
  weekLength > 0 &&
  (
    flag
      ? rowArr[unitIdx].measures[forecastUnitIdx].quarters[qIdx].months?.[weekLength - 1]?.value > 0
      : rowArr[unitIdx].measures[forecastUnitIdx].quarters[qIdx].weeks?.[weekLength - 1]?.value > 0
  );
  return getRatioSelection(oldVal, forecastVal, lyVal, isValidForecast);
};

export const getRatioSelectionOfPhasingGrid = (obj, type: string, isValidForecast: boolean): string => {
  const forecastVal = obj.forecastVal;
  const lyVal = type === 'Units' ? obj.unit_ly : obj.revenue_ly;

  return getRatioSelection(obj.oldValue, forecastVal, lyVal, isValidForecast);
};

export const getRatioSelectionOfEditAllGrid = (obj, isValidForecast: boolean): string => {
  return getRatioSelection(obj.oldVal, obj.forecastVal, obj.ly, isValidForecast);
};

export const getRatioSelectionOfEditAllQuarterGrid = (obj): string => {
  let forecastAddition = 0;

  if(!!obj.weeks){
    obj.weeks.filter((week) => !week.isPast).forEach((week) =>{
      //if(!!!week.isPast){
        forecastAddition=+week.forecastVal;

    });
  }else{
    obj.months.forEach((week) =>{
      forecastAddition=+week.forecastVal;
    });
  }

  return getRatioSelection(obj.oldVal, forecastAddition, obj.ly, forecastAddition > 0);
};

export const getRatioSelection = (
  oldValue: number,
  forecastVal: number,
  lyVal: number,
  isValidForecast: boolean,
): string => {
  if (oldValue > 0) {
    return 'PLANRATIO';
  } else if (forecastVal > 0 && isValidForecast) {
    return 'FORECASTRATIO';
  } else if (lyVal > 0) {
    return 'LYRATIO';
  } else {
    return 'CNTRATIO';
  }
};


export const getRatioTotal = (
 obj, ratioSelection: string
): number => {
  if (ratioSelection === 'PLANRATIO') {
    return obj.originalValue;
  } else if (ratioSelection === 'FORECASTRATIO') {
    return obj.forecastVal;
  } else if (ratioSelection === 'LYRATIO') {
    return obj.ly;
  } else {
    return 1;
  }
};

export const getRatioTotalForQuarter = (
 obj, ratioSelection: string
): number => {
  let forecastAddition = 0;
  let planTotalForEditableWeeks = 0;
  let lyRatio = 0;
  let cntTotal = 0;
  if(!!obj.weeks){
    obj.weeks.filter((week) => !week.isPast).forEach((week) =>{
      //if(!!!week.isPast){
        forecastAddition=forecastAddition + week.forecastVal;
      planTotalForEditableWeeks=planTotalForEditableWeeks + week.originalValue;
      lyRatio = lyRatio + week.ly;
      cntTotal = cntTotal + 1;
    });
  }else{
    obj.months.forEach((week) =>{
      forecastAddition=forecastAddition + week.forecastVal;
      planTotalForEditableWeeks=planTotalForEditableWeeks + week.originalValue;
      lyRatio = lyRatio + week.ly;
      cntTotal = cntTotal + 1;
    });
  }

  if (ratioSelection === 'PLANRATIO') {
    return planTotalForEditableWeeks;
  } else if (ratioSelection === 'FORECASTRATIO') {
    return forecastAddition;
  } else if (ratioSelection === 'LYRATIO') {
    return lyRatio;
  } else {
    return cntTotal;
  }
};

export function arrayMove<T>(arr: T[], fromIndex: number, toIndex: number): T[] {
  const newArr = [...arr];
  const [movedItem] = newArr.splice(fromIndex, 1);
  newArr.splice(toIndex, 0, movedItem);
  return newArr;
}

export const sum = arr => arr.reduce((a, b) => a + b, 0);
export const avg = arr => arr.length ? sum(arr) / arr.length : 0;
